import { render } from "./Household_stop_master.vue?vue&type=template&id=20a8b276&scoped=true"
import script from "./Household_stop_master.vue?vue&type=script&lang=js"
export * from "./Household_stop_master.vue?vue&type=script&lang=js"

import "./Household_stop_master.vue?vue&type=style&index=0&id=20a8b276&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\MAHASBM\\MAHASBM-CODE\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a8b276"]])

export default __exports__